import { gql } from '@apollo/client';
import TENANT_TEMPLATE from 'api/fragments/TENANT_TEMPLATE';
const GET_CURRENT_TENANT_TEMPLATES = gql `
  ${TENANT_TEMPLATE}
  query GetCurrentTenantTemplates($first: Int, $after: String, $name: String) {
    me {
      id
      currentTenant {
        id
        templates(first: $first, after: $after, name: $name) {
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            node {
              ...TenantTemplateFragment
            }
          }
        }
      }
    }
  }
`;
export default GET_CURRENT_TENANT_TEMPLATES;
